import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import DummyGroupBoxViewModelType from '@/ViewModels/Controls/DummyGroupBoxViewModel';
import LabelType from '@/Controls/Label';
import Factory from '@/Factories/Factory';
import ControlFactory from '@/Factories/ControlFactory';
import GroupFactory from '@/Factories/GroupFactory';
import ControlFactoryTuple from '@/Factories/ControlFactoryTuple';
import GroupFactoryTuple from '@/Factories/GroupFactoryTuple';
import LayoutFactory from '@/Factories/LayoutFactory';
import * as CoreFrameDTOs from "coreframetypings/dto";

export default class DummyGroupBox extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;
    private content: JQuery;

    public constructor(private viewModel: DummyGroupBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');
        this.content = $('<div class="c-content">').appendTo(this.jQueryControl);

        const tuples: Array<ControlFactoryTuple | GroupFactoryTuple> = [];

        const itemPromise = this.createItemsAsync(this.viewModel.detailViewItems, async i => {
            const { tuple } = await this.createDvItemAsync(i);
            if (this.isDisposed)
                return;

            tuples.push(tuple);
        });

        const groupPromise = this.createItemsAsync(this.viewModel.detailViewGroups, async g => {
            const { tuple } = await this.createGroupAsync(g);
            if (this.isDisposed)
                return;

            tuples.push(tuple);
        });

        Promise.all([itemPromise, groupPromise]).then(() => {
            this.createLayoutAsync(tuples.filter(t => t != null)).then(({ tuple }) => {
                if (this.isDisposed)
                    return;

                this.content.append(tuple?.control);
            });
        });

        this.applyBindings(this.jQueryControl, {
            controlName: 'dummygroupbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.definePureComputed({
                read: () => {
                    if (!this.viewModel.isVisible()) {
                        return false;
                    }

                    for (let i = 0; i < tuples.length; i++) {
                        if (tuples[i].factory.isVisible()) {
                            return true;
                        }
                    }

                    return false;
                }
            })
        });

        if (this.viewModel.label != null) {
            let label = new this.Label(this.viewModel.label, $('<h1>').prependTo(this.jQueryControl));
            let tuple = label.getTuple();
        }

        this.widget(null);

        return this.jQueryControl;
    }

    private async createDvItemAsync(detailViewItem: CoreFrameDTOs.IDVGItemDTO) {
        return ControlFactory.createInstanceAsync(detailViewItem, this.viewModel.context, {
            isSummaryViewMode: this.viewModel.isSummaryViewMode,
            locator: this.viewModel.locator
        });
    }

    private async createGroupAsync(detailViewGroup: CoreFrameDTOs.IDetailViewGroupDTO) {
        return GroupFactory.createInstanceAsync(detailViewGroup, this.viewModel.context, {
            isSummaryViewMode: this.viewModel.isSummaryViewMode,
            locator: this.viewModel.locator,
        });
    }

    private async createLayoutAsync(tuples: (ControlFactoryTuple | GroupFactoryTuple)[]) {
        return await LayoutFactory.createInstanceAsync(this.viewModel.layout, this.viewModel.context, tuples, {});
    }
}

ComponentManager.setControl('DummyGroupBox', DummyGroupBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');